import { Fancybox } from '@fancyapps/ui';

const gallery = () => {
	// gallery with button
	const gallery = document.querySelector('.gallery');

	// if button exists
	if (gallery === null) {
		return;
	}

	const galleryButtons = gallery.querySelectorAll('.btn-gallery');
	const buttonArray = Array.from(galleryButtons);

	const imagesString = gallery.dataset.images;
	const images = JSON.parse(imagesString);

	galleryButtons.forEach((button) => {
		button.addEventListener('click', (e) => {
			// check element type of button
			// if button is a link

			if (button.tagName !== 'BUTTON') {
				const index = buttonArray.indexOf(button);
				//hotelFancybox.jumpTo(index);

				const hotelFancybox = new Fancybox(images, {
					on: {
						initCarousel: (fancybox) => {
							fancybox.jumpTo(index);
						}
					}
				});
			} else {
				const hotelFancybox = new Fancybox(images);
			}
		});
	});
};

export default gallery;
